<script setup>
import { computed, defineEmits, defineProps } from 'vue'
import FilterBuilderGroup from './FilterBuilderGroup.vue'
import { previewFilterExpr } from '@/utils/dealExportFilters'

const props = defineProps({
  modelValue: { type: Object, required: true },
  statusOptions: { type: Array, default: () => [] },
  groupOptions: { type: Array, default: () => [] },
  offerTagOptions: { type: Array, default: () => [] },
})

const emit = defineEmits(['update:modelValue'])

const preview = computed(() => previewFilterExpr(props.modelValue))
</script>

<template>
  <div class="filter-builder">
    <FilterBuilderGroup
      :modelValue="modelValue"
      :statusOptions="statusOptions"
      :groupOptions="groupOptions"
      :offerTagOptions="offerTagOptions"
      isRoot
      @update:modelValue="emit('update:modelValue', $event)"
    />
    <p class="preview-line"><strong>Превью:</strong> {{ preview }}</p>
  </div>
</template>

<style scoped>
.filter-builder {
  display: grid;
  gap: 0.5rem;
}

.preview-line {
  margin: 0;
  font-size: 0.85rem;
  color: #475569;
  word-break: break-word;
}
</style>
